export function isLightOrDark(color: string): 'light' | 'dark' {
  let r = 0,
    g = 0,
    b = 0;

  if (color.startsWith('rgb')) {
    const match = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)/);
    if (match) {
      r = parseInt(match[1] ?? '0', 10);
      g = parseInt(match[2] ?? '0', 10);
      b = parseInt(match[3] ?? '0', 10);
    }
  } else if (color.startsWith('#')) {
    let hex = color.slice(1);
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map((c) => c + c)
        .join('');
    }

    const num = parseInt(hex, 16);
    r = (num >> 16) & 255;
    g = (num >> 8) & 255;
    b = num & 255;
  } else {
    throw new Error(`Formato de cor inválido: ${color}`);
  }

  const hsp = Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));

  return hsp > 127.5 ? 'light' : 'dark';
}
